import { z } from 'zod';
/** Dados externos nunca fornecem URL arbitrária; somente destinos conhecidos com UUID válido. */
export function notificationRoute(data: Record<string, string> | undefined, persona: 'clinica' | 'tecnicos'): string {
  if (data === undefined) return '/';
  const type = data['targetType'];
  const id = data['targetId'] ?? data['maintenanceRequestId'];
  if (type === 'PAYOUT' && persona === 'tecnicos') return '/perfil/recebimento';
  if (id === undefined || !z.string().uuid().safeParse(id).success) return '/';
  if (persona === 'clinica') return `/manutencoes/${id}`;
  return type === 'OFFER' ? `/oferta/${id}` : `/chamado/${id}`;
}